export default "__VITE_ASSET__ZE$kBF8K__"